import { post } from '../utils/HTTP';  

export async function getChatbotAnswers(queryText: any ) { 
    try { 
        let req = {};
        req['queryText'] = queryText;
        const response = await post('/GetChatbotRes', req);  
        return response['data']; 
    }  catch (error) {
        return false;
    }
}
